/**
* @author heiyehk
* @version 1.0
*/
const api = 'https://api.xiaoantech.com/web/sns';

var Ajax = {
    get: function(url){
        // XMLHttpRequest对象用于在后台与服务器交换数据
        return new Promise(function(resolve,reject){
            var xhr = new XMLHttpRequest();            
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function() {
                // readyState == 4说明请求已完成
                if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) { 
                // 从服务器获得数据 
                    resolve(xhr.responseText);
                }
            };
            xhr.send();
        })
    }
};
const dingTalkLogin = {
    install: function (Vue, options) {
        Vue.prototype.$getDDCode = function(data){
            var obj = DDLogin({//创建钉钉扫码区域
                id: data.idname,
                goto: 'https%3A%2F%2Foapi.dingtalk.com%2Fconnect%2Fqrconnect%3Fappid%3D' + data.appid + '%26response_type%3Dcode%26scope%3Dsnsapi_login%26state%3DSTATE%26redirect_uri%3D' + encodeURIComponent(data.gourl)
            });
            let ddiframe = window.document.getElementById(data.idname).children[0];
            ddiframe.width = data.width;
            ddiframe.height = data.height;
            var hanndleMessage = function (event) {
                var origin = event.origin;
                if( origin == "https://login.dingtalk.com" ) {
                    const loginTmpCode = event.data;
                    let durl = 'https://oapi.dingtalk.com/connect/qrconnect?appid=' + data.appid + '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + data.gourl;
                    let godd = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + data.appid + '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + durl + '&loginTmpCode=' + loginTmpCode;
                    window.location.href = godd;//需要跳转这个链接然后返回redirect_uri
                }
            };
            if (typeof window.addEventListener != 'undefined') {
                window.addEventListener('message', hanndleMessage, false);
            } else if (typeof window.attachEvent != 'undefined') {
                window.attachEvent('onmessage', hanndleMessage);
            }//增加触发事件
        };
        Vue.prototype.$getDDUserInfo = async function(data) {
            let code = data.parameter;
            code = code.replace('?','').split('&');
            code = code[0].split('=');//获取跳转后code
            let token =  await Ajax.get(api + '/token?appId=' + data.appid + '&appSecret=' + data.appsecret);//获取token
            try{
                token = JSON.parse(token).data;
                const at = token.access_token;
                let astoken = await Ajax.get(api + '/persistentCode?accessToken=' + at + '&tmpAuthCode=' + code[1]);//获取持久token
                try{
                    astoken = JSON.parse(astoken).data;
                    let snstoken = await Ajax.get(api + '/snsToken?accessToken=' + at + '&openId=' + astoken.openid + '&persistentCode=' + astoken.persistent_code);//获取snstoken
                    try{
                        snstoken = JSON.parse(snstoken).data;
                        let userInfo = await Ajax.get(api + '/userInfo?snsToken=' + snstoken.sns_token);//获取userinfo
                        userInfo = JSON.parse(userInfo);
                        data.success(userInfo);
                    } catch(err) {
                        console.log(err);
                    }
                } catch(err) {
                    console.log(err);
                }
            } catch(err) {
                console.log(err);
            }
        }
    }
}
export default dingTalkLogin;


// WEBPACK FOOTER //
// ./src/components/dingtalk/dtLogin.js